import * as React from 'react';
import { SlideContext } from '../../../../utils/slideContext';
import { useSlideContextBuilder } from '../../../../utils/useSlideContextBuilder';
import * as styles from './Slide.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Slide = function Slide(_ref) {
  var index = _ref.index,
      children = _ref.children;
  var slideContext = useSlideContextBuilder(index);
  return React.useMemo(function () {
    return /*#__PURE__*/_jsx(SlideContext.Provider, {
      value: slideContext,
      children: /*#__PURE__*/_jsx("li", {
        className: styles['container'],
        children: children
      })
    });
  }, [children, slideContext]);
};